import Grid from "@mui/material/Grid";
import { Card } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import { sorgular, serbestSorgular } from "sorgu/queries";
import { IoWallet, IoGlobe, IoBuild } from "react-icons/io5";
import { FaShoppingCart } from "react-icons/fa";
import { IoMegaphone, IoTime } from "react-icons/io5";

const duyurular = [
  {
    id: 1,
    baslik: "Yeni Tapu Sorguları Eklendi",
    icerik: "İstanbul, Kocaeli ve genel tapu bölge sorguları artık aktif. Ada/parsel bazlı arama yapabilirsiniz.",
    tarih: "22 Şubat 2026",
    tip: "yeni",
  },
  {
    id: 2,
    baslik: "Bakım Çalışması - 25 Şubat",
    icerik: "25 Şubat saat 03:00-05:00 arası planlı bakım yapılacaktır. Bu süre içinde sorgular geçici olarak devre dışı kalabilir.",
    tarih: "20 Şubat 2026",
    tip: "uyari",
  },
  {
    id: 3,
    baslik: "GSM Sorgu Hız İyileştirmesi",
    icerik: "GSM > TC ve TC > GSM sorgularında %40 hız artışı sağlandı. Sonuçlar artık daha hızlı dönecektir.",
    tarih: "18 Şubat 2026",
    tip: "guncelleme",
  },
  {
    id: 4,
    baslik: "Panel Kur Özelliği Aktif",
    icerik: "Kendi markalı sorgu panelinizi oluşturabilirsiniz. Sol menüden 'Panel Kur' seçeneğine tıklayın.",
    tarih: "15 Şubat 2026",
    tip: "yeni",
  },
];

const tipRenk = {
  yeni: { bg: "rgba(1, 163, 164, 0.15)", renk: "#01a3a4" },
  uyari: { bg: "rgba(255, 159, 67, 0.15)", renk: "#ff9f43" },
  guncelleme: { bg: "rgba(72, 52, 212, 0.15)", renk: "#4834d4" },
};

function Dashboard({ kullanici }) {
  const aktif = kullanici?.bayi?.aktif_sorgular || null;

  let toplamSorgu = 0;
  Object.values(sorgular).forEach((kat) => {
    Object.keys(kat.sorgu).forEach((kod) => {
      if (aktif === null || aktif.includes(kod)) toplamSorgu++;
    });
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            {kullanici?.bayi_mod && kullanici?.bayi ? (
              <>
                <Grid item xs={12} md={6} xl={3}>
                  <MiniStatisticsCard
                    title={{ text: "bakiye" }}
                    count={kullanici.bayi.bakiye + "₺"}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: <IoWallet size="22px" color="white" /> }}
                  />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <MiniStatisticsCard
                    title={{ text: "lisans" }}
                    count={kullanici.bayi.lisans_bitis ? new Date(kullanici.bayi.lisans_bitis).toLocaleDateString("tr-TR") : "-"}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: <IoGlobe size="22px" color="white" /> }}
                  />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <MiniStatisticsCard
                    title={{ text: "müşteri" }}
                    count={String(kullanici.bayi.musteri_sayisi || 0)}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: <IoBuild size="22px" color="white" /> }}
                  />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <MiniStatisticsCard
                    title={{ text: "aktif sorgu" }}
                    count={String(kullanici.bayi.aktif_sorgular?.length || 0)}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: <FaShoppingCart size="20px" color="white" /> }}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} md={6} xl={4}>
                  <MiniStatisticsCard
                    title={{ text: "toplam sorgu" }}
                    count={String(toplamSorgu)}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: <IoGlobe size="22px" color="white" /> }}
                  />
                </Grid>
                <Grid item xs={12} md={6} xl={4}>
                  <MiniStatisticsCard
                    title={{ text: "ücretsiz" }}
                    count={String(serbestSorgular.length)}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: <IoWallet size="22px" color="white" /> }}
                  />
                </Grid>
                <Grid item xs={12} md={6} xl={4}>
                  <MiniStatisticsCard
                    title={{ text: "rol" }}
                    count={kullanici?.rol || "-"}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: <IoBuild size="22px" color="white" /> }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </VuiBox>

        <VuiBox>
          <Card>
            <VuiBox p={3}>
              <VuiBox display="flex" alignItems="center" mb={2}>
                <IoMegaphone size="20px" color="#0075FF" />
                <VuiTypography variant="lg" color="white" fontWeight="bold" ml={1}>
                  Duyurular
                </VuiTypography>
              </VuiBox>
              {duyurular.map((d) => {
                const stil = tipRenk[d.tip] || tipRenk.guncelleme;
                return (
                  <VuiBox
                    key={d.id}
                    mb={2}
                    p={2}
                    sx={{
                      background: stil.bg,
                      borderRadius: "12px",
                      borderLeft: `3px solid ${stil.renk}`,
                    }}
                  >
                    <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                      <VuiTypography variant="button" color="white" fontWeight="bold">
                        {d.baslik}
                      </VuiTypography>
                      <VuiBox display="flex" alignItems="center" gap={0.5}>
                        <IoTime size="12px" color="#a0aec0" />
                        <VuiTypography variant="caption" color="text">
                          {d.tarih}
                        </VuiTypography>
                      </VuiBox>
                    </VuiBox>
                    <VuiTypography variant="caption" color="text" fontWeight="regular">
                      {d.icerik}
                    </VuiTypography>
                  </VuiBox>
                );
              })}
            </VuiBox>
          </Card>
        </VuiBox>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
